const FALLBACK_LOCALE = 'fi';
const SUPPORTED_LOCALES = ['fi', 'en'];
const isSupportedLocale = (locale) => SUPPORTED_LOCALES.includes(locale);
export const getLocalized = (value, locale) => {
    const base = locale.split('-')[0];
    const key = isSupportedLocale(base) ? base : FALLBACK_LOCALE;
    return value[key] || value[FALLBACK_LOCALE] || value.en;
};
